import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import {
  GetDigitalSignatureSettingsClientResponse,
  SignatureSettings,
} from '../../@types/digitalSignature/getDigitalSignatureSettings'

type OTPProps = {
  email: string | null
  phone: string | null
}

type Store = {
  signatureTypeSelected: SignatureSettings | null
  OTPData: OTPProps | null
  isSendSignature: boolean
  isInitialSignatureClicked: boolean
  isChangedDigitalSignature: boolean
  settings: GetDigitalSignatureSettingsClientResponse | null
  setOPTData: (OTPData: OTPProps | null) => void
  setIsSendSignature: (isSendSignature: boolean) => void
  setIsChangedDigitalSignature: (isChangedDigitalSignature: boolean) => void
  setIsInitialSignatureClicked: (isInitialSignatureClicked: boolean) => void
  setSettings: (settings: GetDigitalSignatureSettingsClientResponse) => void
  setSignatureTypeSelected: (signatureTypeSelected: SignatureSettings) => void
}

export const useDigitalSignatureSettingsStore = create<Store>()(
  devtools(
    (set) => ({
      signatureTypeSelected: null,
      settings: null,
      isSendSignature: false,
      isInitialSignatureClicked: false,
      OTPData: null,
      isChangedDigitalSignature: false,
      setSettings: (settings) => set({ settings }),
      setIsChangedDigitalSignature: (isChangedDigitalSignature) =>
        set({ isChangedDigitalSignature }),
      setIsSendSignature: (isSendSignature) => set({ isSendSignature }),
      setIsInitialSignatureClicked: (isInitialSignatureClicked) =>
        set({ isInitialSignatureClicked }),
      setOPTData: (OTPData) => set({ OTPData }),
      setSignatureTypeSelected: (signatureTypeSelected) =>
        set({ signatureTypeSelected }),
    }),
    { name: 'DigitalSignatureSettingsStore ' },
  ),
)
